import { render } from "./BaseModalSmall.vue?vue&type=template&id=2f81405c"
import script from "./BaseModalSmall.vue?vue&type=script&lang=js"
export * from "./BaseModalSmall.vue?vue&type=script&lang=js"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__